var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fd2860;stroke-miterlimit:10;stroke-width:4px;}.cls-2{fill:#fd2860;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "loading 404") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M630.65,314.09V571.45h85.78v85.78H630.65V743H544.86V657.23H373.29V485.66h85.78V399.87h85.79V314.09ZM459.07,485.66v85.79h85.79V485.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M888,657.23H802.22V399.87H888V314.09h171.57v85.78h85.79V657.23h-85.79V743H888Zm171.57,0V399.87H888V657.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1488.51,314.09V571.45h85.79v85.78h-85.79V743h-85.78V657.23H1231.15V485.66h85.79V399.87h85.79V314.09ZM1316.94,485.66v85.79h85.79V485.66Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M652.65,336.09V593.45h85.78v85.78H652.65V765H566.86V679.23H395.29V507.66h85.78V421.87h85.79V336.09ZM481.07,507.66v85.79h85.79V507.66Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M910,679.23H824.22V421.87H910V336.09h171.57v85.78h85.79V679.23h-85.79V765H910Zm171.57,0V421.87H910V679.23Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1510.51,336.09V593.45h85.79v85.78h-85.79V765h-85.78V679.23H1253.15V507.66h85.79V421.87h85.79V336.09ZM1338.94,507.66v85.79h85.79V507.66Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.609287f8f3923c46a8187be1fd860266.svg";
export { ForwardRef as ReactComponent };